import { handleActions } from 'redux-actions';

import get from 'lodash/get';

import { createSelectOptionsFromSysEnums } from '../../../shared/form-elements/select';
import checkPermissions from '../../../shared/check-permissions';
import endpoints from '../../../../config/endpoints';
import http from '../../../shared/http';

export const namespace = 'offerGeoRulesEdit';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const SET_INITIAL_VALUES = `${namespace}/set-initial-values`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

const FETCH_LOOKUPS_SUCCESS = `${namespace}/fetch-lookups-success`;
const FETCH_LOOKUPS_ERROR = `${namespace}/fetch-lookups-error`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

const initialFormValues = {};

function mapResponseDataToStateData(data) {
	return {
		...data.reduce((acc, value) => ({ ...acc, [`rules_${value.language}`]: value.rules }), {}),
		country: !data[0].country_code ? null : [{
			value: data[0].country_code,
			label: data[0].country_name
		}]
	};
}

// actions
export const actions = {
	own: {
		fetchData: (props) => (dispatch) => {
			const code = props.params.code;

			if (!code) {
				return dispatch({ type: SET_INITIAL_VALUES });
			}

			const request = http({
				url: endpoints.GEO_RULES.SINGLE.replace('{code}', code),
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			});

			return request(dispatch);
		},
		onSubmit: (values, _, props) => (dispatch, getState) => {
			const payload = selectors.getLanguages(getState()).map((lang) => ({
				country_code: get(values, 'country[0].value', null),
				language: lang.id,
				rules: values[`rules_${lang.id}`] || values['rules_en']
			}));

			const code = props.params.code;

			dispatch(actions.own.toggleProgressBar());

			const request = http({
				url: code ? endpoints.GEO_RULES.SINGLE.replace('{code}', code) : endpoints.GEO_RULES.BASE,
				method: code ? 'put' : 'post',
				actions: [SET_INITIAL_VALUES, FETCH_DATA_ERROR],
				data: payload
			});

			return request(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),

		locationsLookups: text => dispatch => {
			const request = http({
				url: `${endpoints.LOOKUPS.LOCATION_CODES}?query=${text}`,
				method: 'get',
				actions: [FETCH_LOOKUPS_SUCCESS, FETCH_LOOKUPS_ERROR]
			});

			return request(dispatch).then((action) => {
				if (action.type === FETCH_LOOKUPS_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		}
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: mapResponseDataToStateData(action.payload.data),
			isLoading: false,
			isError: false
		}),
		[SET_INITIAL_VALUES]: (state, action) => ({
			...state,
			data: initialFormValues,
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	}
);

// reducers
export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getLanguages: (state) => state.root.lists['languages'].filter((lang) => ['en', 'ru', 'uk'].includes(lang.id)),
	getCan: (state) => checkPermissions(state, { edit: 'offers_create' })
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/geo-rules/edit/index.js